var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE3F1",
    fillRule: "evenodd",
    d: "M5.992 5.582C7.663 4.292 9.722 3.23 12 3.23s4.337 1.061 6.008 2.35c1.681 1.297 3.056 2.89 3.98 4.102l.075.1c.556.728 1.014 1.327 1.014 2.217s-.458 1.49-1.014 2.217l-.076.1c-.923 1.212-2.298 2.805-3.979 4.101-1.671 1.29-3.73 2.351-6.008 2.351s-4.337-1.061-6.008-2.35c-1.681-1.297-3.056-2.89-3.98-4.102l-.075-.1C1.38 13.49.923 12.89.923 12s.458-1.49 1.014-2.217l.076-.1C2.936 8.47 4.31 6.878 5.992 5.582M8.308 12c0-2.018 1.653-3.654 3.692-3.654S15.692 9.982 15.692 12 14.04 15.654 12 15.654 8.308 14.018 8.308 12m1.477 0c0-1.21.992-2.192 2.215-2.192s2.215.981 2.215 2.192c0 1.21-.992 2.192-2.215 2.192A2.204 2.204 0 0 1 9.785 12",
    clipRule: "evenodd"
  })));
};
export { SvgEye as ReactComponent };